import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const CTASection = () => {
  return (
    <div className="bg-gray-900 text-white py-12" data-aos='zoom-in'>
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-2xl font-bold mb-4">Ready to Start Your UK Journey?</h2>
        <p className="text-gray-400 mb-6">
          Contact us today for a free consultation and let us help you make your UK immigration dreams a reality.
        </p>
        <div className="text-blue-400 font-semibold">
          <FontAwesomeIcon icon={faPhone} className='me-2 text-xl text-rose-600'/> 0191 250 8966 • <FontAwesomeIcon icon={faEnvelope} className="mx-2 text-white text-xl"/> globalconsultancy3877@gmail.com
        </div>
      </div>
    </div>
  );
};

export default CTASection;